'use strict';

// Product-page real-world builds (WI-30). The section renders the builds
// Liquid can see (the first 50 published); this script re-matches this
// wheel against the complete published set from assets/dha-gallery-index.js
// (WI-27) and rebuilds the cards, count and visibility only if that answer
// differs. Same case-insensitive wheel-code rule as the Gallery's own
// discovery. If the index can't be loaded, the server-rendered answer stays.

(function () {
  var MAX_CARDS = 6;

  function normKey(value) {
    return value == null ? '' : String(value).trim().toUpperCase();
  }

  function span(className, value) {
    var node = document.createElement('span');
    node.className = className;
    node.textContent = value;
    return node;
  }

  function buildCard(build) {
    var card = document.createElement('a');
    card.className = 'dha-pb__card';
    card.href = build.url;
    card.setAttribute('data-url', build.url);

    var media = document.createElement('span');
    media.className = 'dha-pb__media' + (build.contain ? ' dha-pb__media--contain' : '');
    if (build.card) {
      var img = document.createElement('img');
      img.src = build.card;
      img.alt = '';
      img.width = 640;
      img.height = 480;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    card.appendChild(media);

    var name = String((build.make || '') + ' ' + (build.model || '')).replace(/\s+/g, ' ').trim();
    card.appendChild(span('dha-pb__name', name));

    var meta = [build.size, build.finish].map(function (v) { return String(v || '').trim(); }).filter(Boolean).join(' · ');
    if (meta) card.appendChild(span('dha-pb__meta', meta));
    return card;
  }

  function sameUrls(section, shown) {
    var current = Array.prototype.map.call(section.querySelectorAll('.dha-pb__card'), function (c) { return c.getAttribute('data-url'); });
    return current.length === shown.length && current.every(function (url, i) { return url === shown[i].url; });
  }

  function update(section, builds) {
    var code = normKey(section.getAttribute('data-wheel-code'));
    if (!code) return;
    var matches = builds.filter(function (b) { return normKey(b.wheel) === code; });
    var shown = matches.slice(0, MAX_CARDS);
    var eyebrow = section.querySelector('[data-dha-pb-eyebrow]');

    if (!matches.length) {
      section.hidden = true;
      return;
    }
    if (eyebrow) eyebrow.textContent = 'Real-world builds · ' + matches.length;
    if (!sameUrls(section, shown)) {
      var grid = section.querySelector('[data-dha-pb-grid]');
      grid.textContent = '';
      shown.forEach(function (build) { grid.appendChild(buildCard(build)); });
    }
    section.hidden = false;
  }

  function init() {
    var sections = document.querySelectorAll('[data-dha-pb]');
    if (!sections.length || !window.DHAGalleryIndex) return;
    window.DHAGalleryIndex.load().then(function (data) {
      Array.prototype.forEach.call(sections, function (section) { update(section, data.builds); });
    }, function () { /* keep the server-rendered answer */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
